<template>
  <div>
    <div class="header">
      <div class="logo">
        <router-link to="/">Made People</router-link>
      </div>
      <div class="primary-nav">
        <router-link to="/">E-commerce Agency</router-link>
        <router-link to="/cases">Work</router-link>
        <router-link to="/services">Our Approach</router-link>
        <router-link to="/join-us">Career</router-link>
      </div>
      <!--      <div class="secondary-nav">-->
      <!--        <router-link to="/contact">Get in touch</router-link>-->
      <!--      </div>-->
    </div>
    <Slide right noOverlay>
      <router-link to="/services">
        <span>Our Approach</span>
      </router-link>
      <router-link to="/cases">
        <span>Work</span>
      </router-link>
      <router-link to="/join-us">
        <span>Career</span>
      </router-link>
      <!--      <router-link to="/contact">-->
      <!--        <span>Contact</span>-->
      <!--      </router-link>-->
    </Slide>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";
export default {
  name: "Header",
  components: {
    Slide
  },
  mounted() {
    let header = document.querySelector(".header");
    let burger = document.querySelector(".bm-burger-button");
    // Initial state
    var scrollPos = 0;
    // adding scroll event
    window.addEventListener("scroll", function() {
      // detects new state and compares it with the new one
      if (scrollPos < -50) {
        if (document.body.getBoundingClientRect().top > scrollPos) {
          header.classList.remove("hide");
          burger.classList.remove("hide");
        } else {
          header.classList.add("hide");
          burger.classList.add("hide");
        }
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
          header.classList.remove("hide");
          burger.classList.remove("hide");
        }
      }
      // saves the new position for iteration.
      scrollPos = document.body.getBoundingClientRect().top;
    });
  }
};
</script>

<style lang="scss">
.bm-menu {
  background: #151515;
  padding-top: 0;
  box-shadow: inset 1px 0 0 rgba(white, 0.1);
  .bm-item-list {
    width: 300px !important;
    padding: 30px 0;
    margin-left: 0;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    a {
      display: block;
      text-align: right;
      padding: 0.7em 50px;
      border-bottom: 0;
      > span {
        margin-left: 0;
        font-weight: 500;
      }
    }
  }
  .bm-cross-button {
    width: 30px;
    height: 30px;
    &.cross-style {
      top: 24px;
      left: 24px;
      .bm-cross {
        left: 14px;
        background: white;
        width: 2px !important;
        height: 30px !important;
      }
    }
  }
}
.bm-burger-button {
  top: 30px;
  right: 50px !important;
  height: 18px;
  width: 30px;
  z-index: 999;
  position: fixed;
  display: none;
  transition: transform 0.3s ease-in-out;
  &.hide {
    transform: translateY(-77px);
  }
  .bm-burger-bars {
    background-color: #151515;
  }
  .line-style {
    position: absolute;
    height: 2px;
    left: 0;
    right: 0;
  }
}
@media (max-width: 1024px) {
  .bm-burger-button {
    display: block;
  }
}
@media (max-width: 767px) {
  .bm-burger-button {
    top: 30px;
    right: 28px !important;
  }
}
</style>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.header {
  position: fixed;
  z-index: 999;
  width: 100%;
  padding: 3vh 5.3vw;
  display: flex;
  transition: transform 0.3s ease-in-out;
  background: transparent;
  a {
    border-bottom: none;
  }
  &.hide {
    transform: translateY(-100%);
    //opacity: 0.3;
  }
  .logo {
    font-weight: 500;
    font-size: 1.3vw;
    flex-basis: 25%;
    flex-grow: 0;
    letter-spacing: -0.05em;
    align-items: center;
    display: flex;
    a {
      text-decoration: none;
      color: inherit;
    }
  }
  .primary-nav {
    flex-grow: 1;
    flex-basis: 55%;
    text-align: center;
    align-items: center;
    justify-content: flex-start;
    display: flex;
    flex-direction: row;
    font-weight: 500;
    a {
      margin-right: 3vw;
    }
  }
  .secondary-nav {
    flex-basis: 20%;
    flex-grow: 0;
    align-items: center;
    justify-content: flex-end;
    display: flex;
    font-weight: 500;
  }
  .primary-nav,
  .secondary-nav {
    a {
      display: inline-block;
      font-size: 0.95vw;
      position: relative;
      text-decoration: none;
      color: inherit;
      &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: -0.3vh;
        left: 0;
        background-color: $black;
        visibility: hidden;
        transform: scaleX(0);
        transition: all 0.3s ease-in-out 0s;
      }
      &:hover:before {
        visibility: visible;
        transform: scaleX(1);
      }
      &.router-link-exact-active:before {
        visibility: visible;
        transform: scaleX(1);
      }
    }
  }
}
@media (max-width: $tablet) {
  .header {
    padding: 30px 50px;
    .primary-nav,
    .secondary-nav {
      display: none;
    }
    .logo {
      font-size: 20px;
      flex-basis: 50%;
    }
  }
}
@media (max-width: $mobile) {
  .header {
    padding: 26px 30px;
  }
}
</style>
